<template>
  <div>
    <SelectGroup :options="finalPayMethods"
                 variant="white"
                 :title="null"
                 :label="$t('payment_type')"
                 :required="true"
                 :readonly="readonly"
                 :showlabel="true"
                 v-model="object.forma"/>
    <InputGroup v-model="object.paid"
                type="number"
                :readonly="readonly"
                :label="$t('sum')"
                :showErrors="true"
                validationId="paid"
                :required="true"/>
  </div>
</template>

<script setup>
import SelectGroup from "@/components/form/SelectGroup"
import { useStore} from "vuex"
import InputGroup from "@/components/form/InputGroup.vue"
import {computed} from "vue"

const store = useStore()

const props = defineProps({
  object: {
    type: Object
  },
  selectOptions: {},
  field: {},
  required: {},
  value: {},
  selectModels: {}
})

const pay_methods = computed(() => store.state.auth.pay_methods)
const readonly = computed(() => {
  return props.object.forma === 4 // insurance
      || props.object.forma === 5 // deposit
      || props.object.forma === 6 // bonus
})

const finalPayMethods = computed(() => {
  return pay_methods.value.filter(x => {
    const num = Number(x.id)
    if(num === 100) return false
    if(num === 4 && props.object.forma !== 4) return false
    if(num === 5 && props.object.forma !== 5) return false
    if(num === 6 && props.object.forma !== 6) return false
    return true
  })
})
</script>
